import pluralize from 'pluralize';

import humanize from 'underscore.string/humanize';

import contactType from 'helpers/contact_type';

import scrollToElement from 'helpers/scroll_to_element';

import featureNames from 'constants/feature_names';

angular.module('gym.contacts').controller('EditContactsCtrl', ["$scope", "$rootScope", "$state", "$modal", "$stateParams", "$location", "$window", "$document", "$http", "$q", "$filter", "$timeout", "forms", "contact", "flash", "Contacts", "GTMService", "loadingAnimation", "FeatureAvailabilityService", "EmploymentService", "gym", "ConvertToMemberService", "NacConvertToMemberService", "NacConvertToProspectService", "ConvertToNacService", "FormFieldDisplayingService", "ContactWalletService", "ContactFlagsService", "MobileApp", "ReactModal", "paymentMethods", "secondProviderPaymentMethods", "relationships", function($scope, $rootScope, $state, $modal, $stateParams, $location, $window, $document, $http, $q, $filter, $timeout, forms, contact, flash, Contacts, GTMService, loadingAnimation, FeatureAvailabilityService, EmploymentService, gym, ConvertToMemberService, NacConvertToMemberService, NacConvertToProspectService, ConvertToNacService, FormFieldDisplayingService, ContactWalletService, ContactFlagsService, MobileApp, ReactModal, paymentMethods, secondProviderPaymentMethods, relationships) {
  var archiveInstance, getAlternatePaymentMethod, getFlags, isMobileWidth, ref, ref1, reloadContact, reloadPaymentMethods, removeStyle, selectForm, validateContactTab;
  $scope.gym = gym.attributes;
  $scope.profileForms = _.reject(forms.asJson(), function(form) {
    var ref;
    switch (form.name) {
      case 'member_portal_details':
        return !FeatureAvailabilityService.isAvailable('member_portal') || !$scope.gym.gym_config.show_member_portal_switch;
      case 'member_mobile_app_details':
        return !$scope.gym.mobile_app_enabled;
      default:
        return (ref = form.name) === 'bookings' || ref === 'contact_information' || ref === 'notes';
    }
  });
  $scope.attendanceForm = _.filter(forms, function(form) {
    return form.name === 'bookings';
  })[0];
  $scope.attendanceTab = 'bookings';
  $scope.contactInformationForm = _.filter(forms, function(form) {
    return form.name === 'contact_information';
  })[0];
  $scope.editContact = contact.clone();
  $scope.editContact.rootObjectName = 'contact';
  $scope.paymentMethods = paymentMethods;
  $scope.secondProviderPaymentMethods = secondProviderPaymentMethods;
  $scope.filteredPaymentMethods = _.filter(paymentMethods, function(item) {
    return item.last4;
  });
  $scope.filteredSecondProviderPaymentMethods = _.filter(secondProviderPaymentMethods, function(item) {
    return item.last4;
  });
  $scope.permissions = EmploymentService.get().permissions;
  $scope.currency_symbol = $scope.gym.currency_symbol;
  $scope.relationships = relationships;
  $scope.initializedTabs = {};
  $scope.isSharingPayments = ((ref = ContactWalletService.getDefaultPaymentMethod([].concat(paymentMethods, secondProviderPaymentMethods))) != null ? (ref1 = ref.all_contacts) != null ? ref1.length : void 0 : void 0) > 1;
  $scope.featureNames = featureNames;
  getAlternatePaymentMethod = function() {
    if (secondProviderPaymentMethods.getList) {
      return Contacts.one(`${contact.id}`).doGET('alternate_payment_method').then(function(alternatePaymentMethod) {
        return $scope.alternatePaymentMethod = alternatePaymentMethod;
      });
    }
  };
  getAlternatePaymentMethod();
  $scope.formattedContactType = function() {
    var type;
    type = $stateParams.contactType === 'non_attending_contacts' ? 'non-attending' : $stateParams.contactType.slice(0, -1);
    return $filter('capitalize')(type);
  };
  GTMService.trackPage(`${$scope.formattedContactType()} Details`);
  $scope.featureAvailable = function(feature) {
    return FeatureAvailabilityService.isAvailable(feature);
  };
  $scope.reloadMobileAppSettings = function() {
    if (!$scope.gym.mobile_app_enabled) {
      return;
    }
    return MobileApp.all('settings').getList().then(function(data) {
      return $scope.mobileAppSettings = data.plain()[0];
    });
  };
  $scope.reloadMobileAppSettings();
  getFlags = function() {
    return $scope.editContact.all('flags').getList().then(function(flags) {
      return $scope.contactFlags = flags;
    });
  };
  getFlags();
  $scope.reloadFlags = function() {
    return getFlags();
  };
  $scope.isContactAvailable = function() {
    return $scope.permissions.view_contact_profile_page && ($scope.editContact.owner_id === window.currentUser.id || $scope.permissions.manage_other_contacts);
  };
  $scope.showFormField = function(field) {
    return FormFieldDisplayingService.isDisplaying(contact.type, field);
  };
  $scope.isFormEditable = function(form) {
    var ref2;
    return !form.collection && $scope.permissions.manage_contacts && ((ref2 = form.name) !== 'member_portal_details' && ref2 !== 'member_mobile_app_details');
  };
  $scope.hideError = function(field, form = $scope.editContactForm) {
    var ref2;
    return (ref2 = $scope.editContact[form.name].errors) != null ? ref2[field.name] = [] : void 0;
  };
  $scope.tabAvailable = function(tab) {
    var ref2;
    switch (tab) {
      case 'payments':
        return $scope.permissions.view_member_payments && ($scope.editContact.type === 'member' || $scope.isNonAttending());
      case 'attendance':
        return !$scope.isNonAttending() && $scope.featureAvailable('attendance');
      case 'comms':
        return $scope.permissions.send_comms;
      case 'waivers':
        return (ref2 = $scope.gym.gym_waiver_detail) != null ? ref2.enabled : void 0;
      case 'sequences':
        return $scope.gym.sequences_enabled;
      case 'workouts':
        return $scope.permissions.view_workouts && $scope.gym.workouts_enabled;
      case 'access_control':
        return ($scope.gym.brivo_enabled && $scope.permissions.manage_brivo_access_for_contacts) || $scope.gym.innertelligence_enabled;
      case 'policies':
        return $scope.gym.uses_privacy_policies;
      case 'data_series':
        return $scope.gym.data_series_enabled;
      case 'mandates':
        return $scope.gym.uses_gocardless && ($scope.isNonAttending() || $scope.editContact.type === 'member');
      case 'gradings':
        return $scope.editContact.type === 'member' && $scope.gym.is_martial_arts;
      case 'mobile_app':
        return ($scope.editContact.type === 'member' || $scope.isNonAttending()) && $scope.gym.mobile_app_enabled;
      case 'credit_balance':
        return $scope.featureAvailable('credit_vouchers') && ($scope.isMember() || $scope.isNonAttending());
      default:
        return true;
    }
  };
  $scope.sequence_id = $stateParams.sequence_id;
  $scope.reportReferrer = $stateParams.report_referrer;
  validateContactTab = function() {
    if (!$scope.permissions.view_member_payments && $scope.tab === 'payments') {
      $scope.tab = 'activity';
    }
    if (!$scope.permissions.send_comms && $scope.tab === 'comms') {
      return $scope.tab = 'activity';
    }
  };
  validateContactTab();
  $scope.setTab = function(tab, params = {}) {
    if ($location.search().tab || $location.search().sequence_id) {
      $location.search({
        'tab': void 0,
        sequence_id: void 0
      });
    }
    $scope.tab = tab;
    $scope.initializedTabs[$scope.tab] = true;
    $location.hash(tab);
    $scope.setAttendanceTab(params.attendanceTab || 'bookings');
    return $scope.tabParams = params.tabParams || {};
  };
  $scope.setAttendanceTab = function(tab) {
    return $scope.attendanceTab = tab;
  };
  $scope.gocardlessDefaultMandateInvalid = function() {
    var payments;
    if (!$scope.gym.uses_gocardless) {
      return false;
    }
    payments = $scope.gym.payment_system ? $scope.paymentMethods : $scope.secondProviderPaymentMethods;
    return !!_.find(payments, function(item) {
      var ref2;
      return item.default && ((ref2 = item.gocardless_status) === 'cancelled' || ref2 === 'expired');
    });
  };
  $scope.isWalletAvailable = function() {
    var ref2;
    return (ref2 = $scope.editContact.type) === 'member' || ref2 === 'non_attending_contact';
  };
  $scope.isMember = function() {
    return $scope.editContact.type === 'member';
  };
  $scope.isNonAttending = function() {
    return $scope.editContact.type === 'non_attending_contact';
  };
  $scope.selectContactForm = function(form) {
    if ($scope.editableSectionName) {
      return $scope.closeFormEdit().then(function() {
        return selectForm(form);
      });
    } else {
      return selectForm(form);
    }
  };
  selectForm = function(form) {
    $scope.formValue = angular.copy($scope.editContact[form.name]);
    $scope.editContactForm = form;
    return $scope.editableSectionName = (function() {
      switch (form.name) {
        case 'contact_information':
          scrollToElement('contact-information');
          return form.name;
        default:
          $scope.scrollToMainSection();
          return 'customForm';
      }
    })();
  };
  $scope.saveContactForm = function(form, value, successMessage) {
    $scope.editContact[form.name] = value;
    return $scope.save(form.id, successMessage);
  };
  $scope.saveImage = function() {
    loadingAnimation.show();
    return $scope.editContact.save({
      validation_context: ''
    }).then(function(contact) {
      loadingAnimation.hide();
      return $scope.editContact = contact;
    }, function() {
      loadingAnimation.hide();
      return flash.error = "Cannot save photo. Please try again.";
    });
  };
  $scope.save = function(context, successMessage) {
    var membershipDetails;
    loadingAnimation.show();
    membershipDetails = $scope.editContact.memberships;
    $scope.editContact.memberships = void 0;
    return $scope.editContact.save({
      validation_context: context
    }).then(function(contact) {
      $scope.editContact = contact;
      flash.success = successMessage || `${$scope.editContactForm.label} saved`;
      loadingAnimation.hide();
      return $scope.editableSectionName = false;
    }, function(response) {
      $scope.editContact.memberships = membershipDetails;
      angular.extend($scope.editContact, response.data);
      if ($scope.editContactForm) {
        $scope.formValue = angular.copy($scope.editContact[$scope.editContactForm.name]);
      }
      loadingAnimation.hide();
      return flash.error = "Update failed. Please fix the errors below";
    });
  };
  $scope.closeFormEdit = function() {
    $scope.editableSectionName = false;
    return reloadContact();
  };
  $scope.reloadContact = reloadContact = function() {
    var deferred;
    deferred = $q.defer();
    contact.get().then(function(updatedContact) {
      if (updatedContact) {
        contact = updatedContact;
        $scope.editContact = angular.extend($scope.editContact, contact.plain());
        $scope.reloadActivity();
        $scope.$emit('contact:updated');
      }
      return deferred.resolve($scope.editContact);
    });
    return deferred.promise;
  };
  $scope.reloadPaymentMethods = reloadPaymentMethods = function() {
    var params, secondParams;
    reloadContact();
    params = paymentMethods.route === 'gocardless' ? {
      wallet: 1
    } : {};
    paymentMethods.getList(params).then(function(data) {
      $scope.paymentMethods = paymentMethods = data;
      return $scope.filteredPaymentMethods = _.filter(paymentMethods, function(item) {
        return item.last4;
      });
    });
    if (secondProviderPaymentMethods.getList) {
      getAlternatePaymentMethod();
      secondParams = secondProviderPaymentMethods.route === 'gocardless' ? {
        wallet: 1
      } : {};
      return secondProviderPaymentMethods.getList(secondParams).then(function(data) {
        $scope.secondProviderPaymentMethods = secondProviderPaymentMethods = data;
        return $scope.filteredSecondProviderPaymentMethods = _.filter(secondProviderPaymentMethods, function(item) {
          return item.last4;
        });
      });
    }
  };
  $scope.reloadRelationships = function() {
    return relationships.getList().then(function(rels) {
      return $scope.relationships = rels;
    });
  };
  $rootScope.$on('contact:reload', function() {
    return reloadContact();
  });
  $rootScope.$on('contact:paymentMethod:updated', function(event, contactId) {
    reloadPaymentMethods();
    return $scope.reloadRelationships();
  });
  $rootScope.$on('contact:setEditableSection', function(event, data) {
    $scope.editableSectionName = data.name;
    return $scope.editSectionParams = data.params || {};
  });
  $rootScope.$on('contact:addCreditVoucher', function() {
    return $scope.addCreditVoucher();
  });
  $rootScope.$on('contact:addBooking', function() {
    return $scope.addBooking();
  });
  isMobileWidth = function() {
    return $window.innerWidth <= 991;
  };
  $rootScope.$on('contact:notes:add', function() {
    return $timeout(function() {
      return $scope.setTab('notes', {
        tabParams: {
          action: 'add'
        }
      });
    });
  });
  $rootScope.$on('contact:tasks:add', function() {
    return $timeout(function() {
      $scope.setTab('tasks');
      if (isMobileWidth()) {
        return $scope.scrollToMainSection();
      }
    });
  });
  $rootScope.$on('contact:comms:open', function() {
    return $timeout(function() {
      $scope.setTab('comms');
      if (isMobileWidth()) {
        return $scope.scrollToMainSection();
      }
    });
  });
  $scope.convertToMember = function(contact) {
    return ConvertToMemberService.convert(contact, gym);
  };
  $scope.nacConvertToProspect = function(contact) {
    return NacConvertToProspectService.convert(contact, gym);
  };
  $scope.nacConvertToMember = function(contact) {
    return NacConvertToMemberService.convert(contact, gym);
  };
  $scope.convertToNac = function() {
    return ConvertToNacService.convert($scope.editContact, gym);
  };
  $scope.addMembership = function() {
    return $state.go('gym.contacts.membership', {
      contactId: $scope.editContact.id
    });
  };
  $scope.addStyle = function() {
    return $scope.editSection('style', {});
  };
  $scope.editStyle = function(id) {
    return $scope.editSection('style', {
      id: id
    });
  };
  $scope.scrollToMainSection = function() {
    return $timeout(function() {
      return scrollToElement('contact-main-section', {
        offset: -100
      });
    }, 50);
  };
  $rootScope.$on('contact:scrollToMainSection', function() {
    return $scope.scrollToMainSection();
  });
  $scope.editSection = function(name, params) {
    $scope.editableSectionName = false;
    $timeout(function() {
      $scope.editableSectionName = name;
      return $scope.editSectionParams = params;
    }, 50);
    if (name !== 'recipients') {
      return $scope.scrollToMainSection();
    }
  };
  $scope.addCreditVoucher = function() {
    var tabParams;
    tabParams = {
      initialState: 'edit'
    };
    return $scope.setTab('credit_balance', {
      tabParams: tabParams
    });
  };
  $scope.addBrivoCredential = function(voucher) {
    $scope.editableSectionName = 'access_control';
    return $scope.editSectionParams = {};
  };
  removeStyle = function(style) {
    var url;
    loadingAnimation.show();
    url = `/gyms/${$scope.gym.id}/${contactType(contact.type)}/${contact.id}/member_styles/${style.id}`;
    return $http.delete(url).then(function() {
      return reloadContact().then(function() {
        flash.success = "Style successfully deleted";
        return loadingAnimation.hide();
      });
    });
  };
  $scope.removeStyle = function(style) {
    var modalInstance;
    if (style.enabled) {
      modalInstance = ReactModal.open({
        component: 'ConfirmRemoveStyle',
        props: {
          style: style
        }
      });
      return modalInstance.then(function(action) {
        var url;
        if (action === 'delete') {
          return removeStyle(style);
        } else {
          loadingAnimation.show();
          url = `/gyms/${$scope.gym.id}/${contactType(contact.type)}/${contact.id}/member_styles/${style.id}`;
          return $http.put(url, {
            member_style: {
              enabled: false
            }
          }).then(function() {
            loadingAnimation.hide();
            flash.success = "Style successfully deactivated";
            return reloadContact();
          });
        }
      });
    } else {
      modalInstance = ReactModal.open({
        component: 'ConfirmRemoveDeactivatedStyle',
        props: {
          style: style
        }
      });
      return modalInstance.then(function() {
        return removeStyle(style);
      });
    }
  };
  $scope.confirmedArchiveInstance = function(instance, form) {
    var name;
    name = pluralize.singular(humanize(form.name)).toLowerCase();
    if ($window.confirm(`Are you sure you want to remove this ${name}?`)) {
      return archiveInstance(instance, form);
    }
  };
  archiveInstance = function(instance, form) {
    var url;
    loadingAnimation.show();
    url = instance.links[0].href;
    return $http.delete(url).then(function() {
      return reloadContact().then(function() {
        var name, ref2;
        name = pluralize.singular(humanize(form.name));
        flash.success = `${name} successfully deleted`;
        if ((ref2 = form.name) === 'suspensions' || ref2 === 'memberships') {
          $scope.$emit('invoices:list:reload');
        }
        return loadingAnimation.hide();
      });
    });
  };
  $scope.archiveRelationship = function(instance) {
    if ($window.confirm("Are you sure you want to remove this relationship?")) {
      loadingAnimation.show();
      return instance.remove().then(function() {
        loadingAnimation.hide();
        flash.success = "Relationship successfully deleted";
        reloadContact();
        return relationships.getList().then(function(rels) {
          return $scope.relationships = rels;
        });
      }, function() {
        return loadingAnimation.hide();
      });
    }
  };
  $scope.goToParent = function() {
    var parent;
    parent = _.find($scope.relationships, function(item) {
      return item.relationship_type === 'Parent / Guardian';
    });
    if (parent) {
      return $state.go('gym.contacts.edit', {
        contactId: parent.related_contact_id,
        contactType: contactType(parent.related_contact_type),
        tab: 'waivers',
        action: 'select_waiver'
      });
    }
  };
  $scope.deleteContact = function() {
    if ($window.confirm(`Are you sure you want to archive ${$scope.editContact.name}?`)) {
      loadingAnimation.show();
      return $scope.editContact.remove().then(function() {
        flash.success = `${$scope.editContact.name} archived successfully`;
        return $state.go('gym.contacts.list');
      });
    }
  };
  $scope.closeEditBookingSection = function() {
    $scope.bookingFilters = {};
    return $scope.editableSectionName = false;
  };
  $scope.onWaitlistAdded = function() {
    return $scope.editContact.on_waitlist = true;
  };
  $scope.addBooking = function() {
    $scope.newBookingParams = {
      bookFriend: false
    };
    $scope.editableBooking = {
      type: 'one',
      count: 1,
      free_class: false
    };
    return $scope.editableSectionName = 'booking';
  };
  $scope.bookFriend = function() {
    $scope.newBookingParams = {
      bookFriend: true
    };
    $scope.editableBooking = {
      free_class: false
    };
    return $scope.editableSectionName = 'booking';
  };
  $scope.showFlags = function() {
    return ContactFlagsService.showFlags($scope.editContact).then(function() {
      return getFlags();
    }, function() {
      return getFlags();
    });
  };
  $scope.openAddFlagModal = function() {
    return ContactFlagsService.editFlag($scope.editContact, 'new').then(function() {
      return getFlags();
    });
  };
  $scope.manageComms = function() {
    return $scope.editSection('recipients');
  };
  $scope.reloadActivity = function() {
    return $scope.$emit('contact:activity:reload');
  };
  $scope.tab = $scope.tabAvailable($location.hash() || $stateParams.tab || 'activity') ? $location.hash() || $stateParams.tab || 'activity' : 'activity';
  return $scope.initializedTabs[$scope.tab] = true;
}]);
